import { memo, useContext } from 'react';
import { Button, message, Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import { CurrentKnowledgeValueContext } from '@knowledge/knowledges/singleClass/context';
import { useUpdateOneKnowledgeInKcList } from '@knowledge/knowledges/singleClass/connect';
import { cloneDeep, findIndex, get, set } from 'lodash-es';
import { useFormikContext } from 'formik';
import { countSku, mergeItems } from '@knowledge/common/helpers/sku';
import {
  transformItemV2Spu2KnowledgeSpu,
  useValueName,
} from '@knowledge/knowledges/singleClass/helpers';
import useModal from 'hooks/useModal';
import {
  ItemSelectV5Drawer,
  ItemSelectV5DrawerSelfProps,
} from '@knowledge/common/components/ItemSelectV5/Index';

/**
 * 单品商品范围追加商品按钮
 */
const MoreSpuButton = memo((props: { citeMode?: boolean; type: string; knowledgeName: string }) => {
  const { t } = useTranslate();
  const { update, loading } = useUpdateOneKnowledgeInKcList();
  const { values, setValues, handleSubmit } = useFormikContext<Knowledge.SingleClass.Knowledge>();
  const { active } = useContext(CurrentKnowledgeValueContext);
  const { visible, show, hide, meta } = useModal<ItemSelectV5DrawerSelfProps>();
  const valueName = useValueName();
  const handleAdd = (items: ItemSelectV2.Item[]) => {
    const copy = cloneDeep(values);
    const index = findIndex(copy.values, (e) => e.id === active);
    const itemsb = items.map((e) => transformItemV2Spu2KnowledgeSpu(e));
    const totalItem = mergeItems(get(values, `values.${index}.spus`, []), itemsb);
    set(copy, `values.${index}.spus`, totalItem);
    if (props.citeMode) {
      setValues(copy);
      handleSubmit();
      hide();
    } else {
      update(copy).then(() => {
        message.success(t('operation.saveSucceed'));
        hide();
      });
    }
  };

  return (
    <>
      <Button
        onClick={() => {
          show({
            renderFooter: (items) => {
              const selectedSkuLen = countSku(items);
              return (
                <div className="flex items-center justify-end text-[var(--fett-text-secondary)]">
                  {!!selectedSkuLen &&
                    (() => {
                      const title = t('knowledge.选中xadd', {
                        x: selectedSkuLen,
                        y: props.knowledgeName,
                        z: valueName,
                      });
                      return (
                        <Tooltip title={title}>
                          <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                            {title}
                          </div>
                        </Tooltip>
                      );
                    })()}
                  <Button
                    loading={loading}
                    className="ml-[8px]"
                    type="primary"
                    onClick={() => {
                      handleAdd(items);
                    }}
                  >
                    {t('phrase.确定')}
                  </Button>
                </div>
              );
            },
          });
        }}
        type="link"
      >
        {t('knowledge.添加更多商品')}
      </Button>
      {visible && meta && (
        <ItemSelectV5Drawer
          visible={visible}
          showSameSellerSkuTag={!props.citeMode}
          {...meta}
          onClose={() => {
            hide();
          }}
        />
      )}
    </>
  );
});

export default MoreSpuButton;
